import { User } from "@fairfleet/geotab";

/** "Last name, first name", falling back to whatever part of the name exists. */
export function formatDriverName(user?: User): string {
  if (!user) return "";

  const lastName = user.lastName?.trim() ?? "";
  const firstName = user.firstName?.trim() ?? "";

  if (lastName && firstName) return `${lastName}, ${firstName}`;

  return lastName || firstName || user.name || "";
}

/** The driver card number lives on the driver key, which the User type does not describe. */
export function extractDriverCardNumber(user: User): string {
  const record = user as unknown as { keys?: unknown[]; employeeNo?: string };
  const firstKey = record.keys?.[0] as Record<string, unknown> | undefined;

  if (firstKey) {
    const candidates = [
      firstKey.cardNumber,
      firstKey.driverCardNumber,
      firstKey.serialNumber,
      firstKey.keyNumber,
      firstKey.id,
    ];

    for (const candidate of candidates) {
      if (typeof candidate === "string" && candidate.trim().length > 0) return candidate.trim();
    }
  }

  return record.employeeNo?.trim() ?? "";
}
